import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import { Logo } from '../Logo';
import { Link } from 'react-router-dom';

function AuthLayout({ children, title, subtitle }) {
  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header */}
      <Box sx={{ py: 4, borderBottom: 1, borderColor: 'divider' }}>
        <Container maxWidth="lg">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Logo />
              <Typography 
                variant="h6" 
                sx={{ 
                  color: 'common.white',
                  fontFamily: 'Anton, sans-serif',
                  letterSpacing: '0.02em'
                }}
              >
                Stack Track
              </Typography>
            </Box>
          </Link>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxWidth="sm" sx={{ flex: 1, py: 8 }}>
        <Paper 
          elevation={0} 
          sx={{ 
            p: 4,
            bgcolor: 'background.paper',
            borderRadius: 2,
            textAlign: 'center'
          }}
        >
          <Typography variant="h4" component="h1" sx={{ color: 'common.white', mb: 1 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
              {subtitle}
            </Typography>
          )}
          {children}
        </Paper>
      </Container>
    </Box>
  );
}

export default AuthLayout; 